<div class="main-page-content">
  <div class="main-page-content-block" *ngIf="currentItem == null">
    <h1 class="content-heading-font">Ticket Status Mappings</h1>

    <div class="row">
      <div class="col-12">
        <p-table #dt1
                 dataKey="ID"
                 [value]="list?.Result"
                 [responsive]="true"
                 [paginator]="true"
                 [rows]="25"
                 [loading]="loadingList"
                 [showCurrentPageReport]="true"
                 currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                 [rowsPerPageOptions]="[10, 25, 50, 100]"
                 [totalRecords]="list?.FilteredRecords"
                 [lazy]="true"
                 (onLazyLoad)="loadTable($event)"
                 styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped"
                 sortMode="multiple">

          <ng-template pTemplate="header">
            <tr>
              <th class="text-end" style="width:120px;"></th>
              <th pSortableColumn="ID" class="text-end d-none d-md-table-cell">
                #
                <p-sortIcon field="ID"></p-sortIcon>
                <p-columnFilter type="numeric" field="ID" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="GitHubStatus" class="text-start">
                GitHub Status
                <p-sortIcon field="GitHubStatus"></p-sortIcon>
                <p-columnFilter type="text" field="GitHubStatus" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="DisplayStatus" class="text-start">
                Display Status
                <p-sortIcon field="DisplayStatus"></p-sortIcon>
                <p-columnFilter type="text" field="DisplayStatus" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="Archived" class="text-start d-none d-lg-table-cell">
                Status
                <p-sortIcon field="Archived"></p-sortIcon>
                <p-columnFilter type="boolean" field="Archived" display="menu" [showMatchModes]="false" [showOperator]="false">
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-dropdown [options]="[{ name: 'Any', value: '' },{ name: 'Active', value: 'false' },{ name: 'Archived', value: 'true' }]" [ngModel]="value" placeholder="Any" (onChange)="filter($event.value)" optionLabel="name" optionValue="value">
                    </p-dropdown>
                  </ng-template>
                </p-columnFilter>
              </th>
              <th pSortableColumn="LastUpdated" class="text-center d-none d-xl-table-cell">
                Last Updated
                <p-sortIcon field="LastUpdated"></p-sortIcon>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr>
              <th class="text-end">
                <div class="gap-2 d-block">
                  <a class="btn btn-sm btn-primary me-1" (click)="onRowEditInit(item)" title="Edit">
                    <i class="pi pi-pen-to-square"></i>
                  </a>
                  <a class="btn btn-sm btn-warning" (click)="onRowDeleteInit(item)" title="Archive">
                    <i class="pi pi-trash"></i>
                  </a>
                </div>
              </th>
              <th class="text-end d-none d-md-table-cell">{{ item.ID }}</th>
              <td>{{ item.GitHubStatus }}</td>
              <td>{{ item.DisplayStatus }}</td>
              <td class="d-none d-lg-table-cell">
                <div [ngClass]="{'text-danger': item.Archived, 'text-success': !item.Archived}">
                  {{ item.Archived ? 'Archived' : 'Active' }}
                </div>
              </td>
              <td class="text-center d-none d-xl-table-cell">{{ item.LastUpdated | date:'short' }}</td>
            </tr>
          </ng-template>

          <ng-template pTemplate="paginatorleft">
            <button class="btn btn-primary" (click)="addItem()" title="Add item">
              <i class="pi pi-plus"></i>
            </button>
            &nbsp;
            <button class="btn btn-primary" (click)="loadTable(null)" title="Refresh">
              <i class="pi pi-refresh" [ngClass]="{'pi-spin': loadingList}"></i>
            </button>
            &nbsp;
            <button class="btn btn-primary" (click)="clear(dt1)" title="Clear Filter">
              <i class="pi pi-filter-slash"></i>
            </button>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6">No items found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <div class="main-page-content-block" *ngIf="currentItem != null">
    <div class="float-end">
      <a class="btn btn-secondary" (click)="cancel()">View list</a>
    </div>

    <h1 class="content-heading-font">
      <span *ngIf="currentItem && currentItem.ID">
        Ticket Status Mapping #{{ currentItem.ID }}
      </span>
      <span *ngIf="!(currentItem && currentItem.ID)">
        New Ticket Status Mapping
      </span>
    </h1>

    <form #itemForm="ngForm" [formGroup]="itemFormGroup">
      <div class="row">
        <div class="col mb-3">
          <label for="GitHubStatus">GitHub Status</label>
          <input class="form-control" name="GitHubStatus" formControlName="GitHubStatus" autocomplete="off" required="required" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="DisplayStatus">Display Status</label>
          <div class="d-flex gap-2 align-items-start">
            <select class="form-control" name="DisplayStatus" formControlName="DisplayStatus" required="required">
              <option value="">Select</option>
              <option *ngFor="let status of displayStatuses" [value]="status">{{ status }}</option>
            </select>
            <button type="button" class="btn btn-outline-primary flex-shrink-0" (click)="addDisplayStatus()" title="Add display status">
              <i class="pi pi-plus"></i>
            </button>
            <button type="button" class="btn btn-outline-primary flex-shrink-0" [disabled]="!itemFormGroup.value.DisplayStatus" (click)="editDisplayStatus()" title="Edit display status">
              <i class="pi pi-pen-to-square"></i>
            </button>
          </div>
          <div *ngIf="editingDisplayStatus" class="mt-2" [formGroup]="displayStatusFormGroup">
            <div class="input-group">
              <input class="form-control" name="DisplayStatusOption" formControlName="DisplayStatus" autocomplete="off" maxlength="100" required="required" />
              <button type="button" class="btn btn-primary" [class.button-loading]="savingDisplayStatus" [disabled]="displayStatusFormGroup.invalid || savingDisplayStatus" (click)="saveDisplayStatus()" title="Save display status">
                <i class="pi pi-save"></i>
              </button>
              <button type="button" class="btn btn-secondary" (click)="cancelDisplayStatusEdit()" title="Cancel display status edit">
                <i class="pi pi-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="Archived">Status</label>
          <select class="form-control" name="Archived" formControlName="Archived">
            <option [ngValue]="false">Active</option>
            <option [ngValue]="true">Archived</option>
          </select>
        </div>
      </div>

      <div class="text-end mt-3">
        <button type="button" class="btn btn-secondary me-2" (click)="cancel()">Cancel</button>
        <button type="button" class="btn btn-primary" [class.button-loading]="loading" [disabled]="itemFormGroup.invalid || loading" (click)="save()">Save</button>
      </div>
    </form>
  </div>
</div>
